export interface ApiResponse<T = any> {
  status: number;
  data: T;
  error?: {
    message: string;
  };
}

export class ApiErrorResponse extends Error {
  status: number;
  message: string;
  data?: any;

  constructor(status: number, message: string, data?: any) {
    super(message);
    this.status = status;
    this.message = message;
    this.data = data;
  }
}
